// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.import-storage-modal {
  --bs-modal-width: 720px;
}

.import-storage-modal-dialog {
  max-width: 720px;
  width: calc(100vw - 32px);
}

.import-modal-footer {
  flex-direction: column;
  align-items: stretch;
}

.import-modal-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.import-modal-actions .org-btn {
  width: 100%;
  min-height: 38px;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/components/LabelStudioProject/ImportStorageModal/ImportStorageModal.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".import-storage-modal {\n  --bs-modal-width: 720px;\n}\n\n.import-storage-modal-dialog {\n  max-width: 720px;\n  width: calc(100vw - 32px);\n}\n\n.import-modal-footer {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.import-modal-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.import-modal-actions .org-btn {\n  width: 100%;\n  min-height: 38px;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
